import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getSitePages(siteUid: string, oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/pages/${siteUid}/`,
    oauthTokenHeader,
  );
}

function getNextPages(nextUrl: any, oauthTokenHeader: string) {
  return fetchWrapper.get(`${nextUrl}`, oauthTokenHeader);
}

function getPageGroups(siteUid: string, oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/page_groups/${siteUid}/`,
    oauthTokenHeader,
  );
}

function updatePageGroup(data: any, siteUid: string, oauthTokenHeader: string) {
  return fetchWrapper.put(
    `${apiUrl}/asset_management/pages/page_group/${siteUid}/`,
    data,
    oauthTokenHeader,
  );
}

function updatePage(
  data: any,
  siteUid: string,
  pageUid: string,
  oauthTokenHeader: string,
) {
  return fetchWrapper.put(
    `${apiUrl}/asset_management/pages/${siteUid}/${pageUid}/`,
    data,
    oauthTokenHeader,
  );
}

function getPageContent(
  siteUid: string,
  pageUid: string,
  oauthTokenHeader: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/pages/${siteUid}/${pageUid}/`,
    oauthTokenHeader,
  );
}

function discardPage(
  data: any,
  siteUid: string,
  pageUid: string,
  oauthTokenHeader: string,
) {
  return fetchWrapper.put(
    `${apiUrl}/asset_management/pages/${siteUid}/${pageUid}/?discard=1`,
    data,
    oauthTokenHeader,
  );
}

function executeQueryPages(
  oauthTokenHeader: string,
  start_date: string,
  end_date: string,
  siteSharedUid: string,
  type: string,
  execute_query_id: string,
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${execute_query_id}/?start_date=${start_date}&end_date=${end_date}&website_shared_uid=${siteSharedUid}&type=${type}`,
    oauthTokenHeader,
  );
}

export const sitePagesService = {
  getSitePages,
  getNextPages,
  getPageGroups,
  updatePageGroup,
  updatePage,
  getPageContent,
  discardPage,
  executeQueryPages,
};
